import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import { View, Text } from 'react-native';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import DataModel from 'root/libs/exaforte/react/DataModel';
import { __IS_MANDATORY__, __CONTENT_TYPE_SELECT__ } from 'root/libs/exaforte/react/ReactModel';
import Config from 'root/globals/Config';
import Components from 'root/Components';
import { ContentDialog, ErrorDialogWrapper } from 'root/globals/Dialog';
import { CustomTextField, CustomCheckBox } from 'root/libs/exaforte/react/Form';
import CustomFileInput from 'root/globals/views/CustomFileInput';
import CustomForm from 'root/libs/exaforte/react/form/CustomForm';
import { FormMessages, FormGroup } from 'root/globals/Form';
import { ButtonGroup } from 'root/globals/Elements';
import styles from './ExportDialog.less';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

import {
    faPlus,
    faTimes,
} from '@fortawesome/pro-regular-svg-icons';

export default class ImportDialog extends CustomComponent {
    constructor(props) {
        super(props);

        this.state      = { step: 'file_select', loading: false, dialog_id: Math.floor((1 + Math.random()) * 0x10000), seperation_sign: ',', first_row_header: 'f', file: null, records: null };
        this.options    = _.map(_.sortBy(this.props.controller.component.state.action_fielddefines.import, fielddefine => parseInt(fielddefine.sortnumber)), this.map_fields);
        this.data_model = new DataModel(this, { name: 'import' });
    }
    
    map_fields(fielddefine) {
        return { value: fielddefine.field, label: fielddefine.label };
    }
    
    _onChangeText(value) {
        this.setState({ seperation_sign: _.is_empty(value) ? value : value.slice(-1) });
    }
    
    _onChangeHeaderSetting(value) {
        this.setState({ first_row_header: value });
    }
    
    _onUploadFile(files) {
        this.setState({ file: files.shift() });
    }
    
    _fetch(action, body) {
        this.setState({ loading: true });
        
        return fetch(Config.SERVER_REQUEST_URL + '?ajax_id=11261' + (action == 'import' ? '&component=' + this.props.component : '') + '&form-action=' + action, { method: 'POST', xhrFields: { withCredentials: true }, headers: { 'X-React-App': 1 }, credentials: 'include', body: _.json_to_form_data(body) }).then(response => response.json());
    }
    
    _uploadFile() {
        this._fetch('view', _.pick(this.state, ['dialog_id', 'file', 'seperation_sign'])).then(this._uploadCallback);
    }
    
    _uploadCallback(response) {
        if(response.status && response.example_row)
        {
            let fielddefines = {};
            
            for(let i in response.example_row)
                fielddefines['field_' + i] = { field: 'field_' + i, label: response.example_row[i], isvisible: 1, fieldtype_id: __CONTENT_TYPE_SELECT__, options: this.options };
            
            this.data_model.set_fields(fielddefines);
            this.setState({ step: 'field_select', loading: false });
        }
        else
            this.setState({ loading: false });
    }
    
    _validate() {
        if(_.is_empty(this.state.import))
            this.data_model.set_response({ errors: { fields: 'Er moet minimaal 1 veld ingevuld worden.' } });
        else
        {
            this.data_model.set_response({ errors: {} });
            
            let default_values = this.props.controller.component._importDefaultValues ? this.props.controller.component._importDefaultValues() : {};
            
            this._fetch('import', { dialog_id: this.state.dialog_id, fields: this.state.import, seperation_sign: this.state.seperation_sign, first_row_header: this.state.first_row_header, default_values }).then(this._validateCallback);
        }
    }
    
    _validateCallback(response) {
        if(response.status)
        {
            let errors = [];
            
            for(let i in response.errors)
                for(let j in response.errors[i])
                    errors.push('Regel ' + (parseInt(i) + 1) + ': ' + response.errors[i][j]);
            
            this.setState({ step: 'result', loading: false, errors, has_model_without_errors: response.has_model_without_errors });
        }
        else
            this.setState({ loading: false });
    }
    
    _save() {
        let default_values = this.props.controller.component._importDefaultValues ? this.props.controller.component._importDefaultValues() : {};
        
        this._fetch('import', { dialog_id: this.state.dialog_id, fields: this.state.import, seperation_sign: this.state.seperation_sign, first_row_header: this.state.first_row_header, default_values, save: 't' }).then(this._saveCallback);
    }
    
    _saveCallback(response) {
        if(response.status)
            this.setState({ step: 'done', loading: false, errors: null, has_model_without_errors: null }, this.props.loadData);
        else
            this.setState({ loading: false });
    }
    
    _reset() {
        this.data_model.set_fields({});
        this.data_model.set_response({ errors: {} });
        this.setState({ step: 'file_select', import: {}, errors: null, has_model_without_errors: null });
    }
    
    _back() {
        if(this.state.step == 'result')
            this.setState({ step: 'field_select', errors: null, has_model_without_errors: null });
        else
            this._reset();
    }
    
    _getScreen() {
        let actions = [];
        let element = null;
        
        switch(this.state.step)
        {
            case 'file_select':
                if(this.props.closeCallback)
                    actions.push({ title: 'Annuleren', secondary: true, onPress: this.props.closeCallback, className: ['ml-2'] });
                
                actions.push({ title: 'Volgende', onPress: this._uploadFile, loading: this.state.loading, disabled: (_.is_empty(this.state.seperation_sign) || _.is_empty(this.state.file)), className: ['ml-2'] });
                
                element = <>
                    <View className={[styles['flex-direction-row'], styles['mb-2']]}>
                        <View className={[styles['mr-1']]}><CustomTextField label="Scheidingsteken (voor CSV bestanden)" onChangeText={this._onChangeText} value={this.state.seperation_sign} /></View>
                        <View><CustomCheckBox label="Instellingen" onChangeText={this._onChangeHeaderSetting} value={this.state.first_row_header} /></View>
                        <Text className={[styles['mt-4'], styles['ml-n4-5'], styles['f-1-5'], styles['text-light'], styles['color-dark-grey']]}>Eerste rij is een header</Text>
                    </View>
                    <CustomFileInput onChangeText={this._onUploadFile} files={_.is_empty(this.state.file) ? [] : [this.state.file]} />
                </>;
                
                break;
            
            case 'field_select':
                actions.push({ title: 'Terug', secondary: true, onPress: this._back, className: ['ml-2'] });
                actions.push({ title: 'Valideren', onPress: this._validate, loading: this.state.loading, className: ['ml-2'] });
                
                element = <>
                    <FormMessages model={this.data_model} />
                    <CustomForm model={this.data_model} fielddefines={this.data_model.get_fields()} row={true} />
                </>;
                
                break;
            
            case 'result':
                actions.push({ title: 'Terug', secondary: true, onPress: this._back, className: ['ml-2'] });
                
                if(!_.is_empty(this.state.errors))
                {
                    actions.push({ title: 'Bestand opnieuw uploaden', onPress: this._reset, className: ['ml-2'] });
                    
                    if(this.state.has_model_without_errors)
                        actions.push({ title: 'Importeren wat mogelijk is', onPress: this._save, loading: this.state.loading, className: ['ml-2'], secondary: true, color: 'yellow', confirmMessage: 'Weet je zeker dat je wilt doorgaan met importeren?' });
                }
                else 
                    actions.push({ title: 'Importeren', onPress: this._save, loading: this.state.loading, className: ['ml-2'] });
                
                element = <CustomFormMessages success_title="Validatie gelukt!" success_message="Alle rijen zijn gevalideerd. Druk op importeren om ze te importeren." errors={this.state.errors} />;
                
                break;
            
            case 'done':
                if(this.props.closeCallback)
                    actions.push({ title: 'Sluiten', secondary: true, onPress: this.props.closeCallback, className: ['ml-2'] });
                
                element = <CustomFormMessages success_title="Importeren gelukt!" success_message="De nieuwe items zijn geimporteerd." />;
                
                break;
        }
        
        return { actions, element };
    }
    
    render() {
        let screen      = this._getScreen();
        let description = '';
        
        if(this.state.step == 'field_select')
            description = 'Koppel hier de kolommen van de eerste rij uit je bestand met de in te voeren velden';

        return (
            <ContentDialog title={'Importeren'} actions={<ButtonGroup buttons={screen.actions} />} maxWidth={this.state.step == 'file_select' ? 'xs' : 'xl'} description={description}>
                <View className={[styles['py-1-5']]} />
                {screen.element}
            </ContentDialog>
        );
    }
}

class CustomFormMessages extends FormMessages {
    render() {
        if(!_.is_empty(this.props.errors))
            return super.render();
        
        return (
            <View className={[styles['background-color-light-green-10'], styles['color-light-green'], 'd-flex flex-row p-3 mb-4']}>
                <FontAwesomeIcon icon={faCheck} className={styles['f-3-5']} />
                <View className={['ml-2']}>
                    <Text>{this.props.success_title}</Text>
                    <Text className={[styles['text-light']]}>{this.props.success_message}</Text>
                </View>
            </View>
        );
    }
}